import React, { useEffect, useState } from "react";
import {
  BuildingOfficeIcon,
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
  UserIcon,
  ClockIcon,
  IdentificationIcon,
} from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { createBranch, editBranch, updateBranch } from "./branchSlice";
import { Branch, BranchFormData } from "./branch";
import BaseModal from "../../components/common/BaseModal";
import FormInput from "../../components/common/FormInput";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import EmailField from "../../form/EmailField";
import PhoneField from "../../form/PhoneField";
import ZipCodeField from "../../form/ZipCodeField";
import StateSelect from "../../form/StateField";
import CitySelect from "../../form/CityField";
import TextInputField from "../../form/TextInputField";
import { cityToStateOptions } from "../../constants/locationOptions"

interface CreateBranchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  branch: Branch | null;
}

// Indian states for dropdown
// const stateOptions = [
//   { value: "Andhra Pradesh", label: "Andhra Pradesh" },
//   { value: "Delhi", label: "Delhi" },
//   { value: "Gujarat", label: "Gujarat" },
//   { value: "Karnataka", label: "Karnataka" },
//   { value: "Kerala", label: "Kerala" },
//   { value: "Maharashtra", label: "Maharashtra" },
//   { value: "Tamil Nadu", label: "Tamil Nadu" },
//   { value: "Telangana", label: "Telangana" },
//   { value: "Uttar Pradesh", label: "Uttar Pradesh" },
//   { value: "West Bengal", label: "West Bengal" },
//   // Add more states as needed
// ];

// // Major cities by state
// const cityOptions: { [key: string]: { value: string; label: string }[] } = {
//   "Andhra Pradesh": [
//     { value: "Visakhapatnam", label: "Visakhapatnam" },
//     { value: "Vijayawada", label: "Vijayawada" },
//   ],
//   Delhi: [
//     { value: "New Delhi", label: "New Delhi" },
//     { value: "Delhi", label: "Delhi" },
//   ],
//   Gujarat: [
//     { value: "Ahmedabad", label: "Ahmedabad" },
//     { value: "Surat", label: "Surat" },
//     { value: "Vadodara", label: "Vadodara" },
//   ],
//   Karnataka: [
//     { value: "Bangalore", label: "Bangalore" },
//     { value: "Mysore", label: "Mysore" },
//   ],
//   Kerala: [
//     { value: "Thiruvananthapuram", label: "Thiruvananthapuram" },
//     { value: "Kochi", label: "Kochi" },
//   ],
//   Maharashtra: [
//     { value: "Mumbai", label: "Mumbai" },
//     { value: "Pune", label: "Pune" },
//     { value: "Nagpur", label: "Nagpur" },
//     { value: "Jalgoan", label: "Jalgoan" },
//     { value: "Nashik", label: "Nashik" },
//   ],
//   "Tamil Nadu": [
//     { value: "Chennai", label: "Chennai" },
//     { value: "Coimbatore", label: "Coimbatore" },
//   ],
//   Telangana: [
//     { value: "Hyderabad", label: "Hyderabad" },
//     { value: "Warangal", label: "Warangal" },
//   ],
//   "Uttar Pradesh": [
//     { value: "Lucknow", label: "Lucknow" },
//     { value: "Kanpur", label: "Kanpur" },
//   ],
//   "West Bengal": [
//     { value: "Kolkata", label: "Kolkata" },
//     { value: "Howrah", label: "Howrah" },
//   ],
//   // Add more cities as needed
// };

const CreateBranchModal: React.FC<CreateBranchModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  branch,
}) => {
  const dispatch = useDispatch();
  const isEditMode = !!branch;
  const [formData, setFormData] = useState<BranchFormData>({
    name: "",
    code: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    phone: "",
    email: "",
    status: true,
    managerName: "",
    managerPhone: "",
    managerEmail: "",
    workingHours: {
      start: "09:00",
      end: "18:00",
    },
  });
  const [isFormModified, setIsFormModified] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (formData.city && cityToStateOptions[formData.city]) {
      // If selected state doesn’t match, update it automatically
      if (formData.state !== cityToStateOptions[formData.city]) {
        handleInputChange({
          target: {
            name: "state",
            value: cityToStateOptions[formData.city],
          },
        } as React.ChangeEvent<HTMLInputElement>);
      }
    }
  }, [formData.city]);

  useEffect(() => {
    // Clear city when state is removed or cleared
    if (!formData.state || formData.state === "") {
      if (formData.city) {
        handleInputChange({
          target: {
            name: "city",
            value: "",
          },
        } as React.ChangeEvent<HTMLInputElement>);
      }
    } else if (formData.city && cityToStateOptions[formData.city] !== formData.state) {
      // Clear the city if it doesn't belong to the selected state
      handleInputChange({
        target: {
          name: "city",
          value: "",
        },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  }, [formData.state]);



  // useEffect(() => {
  //   console.log("Branch Data =", branch);
  //   if (isOpen) {
  //     if (branch) {
  //       console.log("if branch", branch);
  //       console.log("if branch formdata", formData);
  //       setFormData({
  //         name: branch.name || "",
  //         code: branch.code || "",
  //         address: branch.address || "",
  //         city: branch.city || "",
  //         state: branch.state || "",
  //         zipCode: branch.zipCode || "",
  //         phone: branch.phone || "",
  //         email: branch.email || "",
  //         status: branch.status !== undefined ? branch.status : true,
  //         managerName: branch.managerName || "",
  //         managerPhone: branch.managerPhone || "",
  //         managerEmail: branch.managerEmail || "",
  //         workingHours: {
  //           start: branch.workingHours?.start || "09:00",
  //           end: branch.workingHours?.end || "18:00",
  //         },
  //       });
  //     } else {
  //       console.log("!if branch", branch);
  //       console.log("!if branch formdata", formData);
  //       setFormData({
  //         name: "",
  //         code: "",
  //         address: "",
  //         city: "",
  //         state: "",
  //         zipCode: "",
  //         phone: "",
  //         email: "",
  //         status: true,
  //         managerName: "",
  //         managerPhone: "",
  //         managerEmail: "",
  //         workingHours: {
  //           start: "09:00",
  //           end: "18:00",
  //         },
  //       });
  //     }
  //     setIsFormModified(false);
  //   }
  // }, [isOpen, branch]);

  useEffect(() => {
  console.log("Branch Data =", branch);

  if (!isOpen) return;

  // Only set initial values if the form hasn't been modified yet
  if (!isFormModified) {
    if (branch) {
      console.log("Initializing form with branch:", branch);
      setFormData({
        name: branch.name || "",
        code: branch.code || "",
        address: branch.address || "",
        city: branch.city || "",
        state: branch.state || "",
        zipCode: branch.zipCode || "",
        phone: branch.phone || "",
        email: branch.email || "",
        status: branch.status !== undefined ? branch.status : true,
        managerName: branch.managerName || "",
        managerPhone: branch.managerPhone || "",
        managerEmail: branch.managerEmail || "",
        workingHours: {
          start: branch.workingHours?.start || "09:00",
          end: branch.workingHours?.end || "18:00",
        },
      });
      setError(null); // Clear error when opening edit modal
    } else {
      console.log("Initializing empty form");
      setFormData({
        name: "",
        code: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        phone: "",
        email: "",
        status: true,
        managerName: "",
        managerPhone: "",
        managerEmail: "",
        workingHours: {
          start: "09:00",
          end: "18:00",
        },
      });
      setIsFormModified(false);
      setError(null); // Clear error when opening fresh modal
    }
  }

}, [isOpen, branch, isFormModified]);


  const [availableCities, setAvailableCities] = useState<
    { value: string; label: string }[]
  >([]);

 

  // const [touchedWhileTyping, setTouchedWhileTyping] = useState<{ [key: string]: boolean }>({});

  const [touchedWhileTyping, setTouchedWhileTyping] = useState({
    email: false,
    phone: false,
    zipCode: false,
    managerEmail: false,
    managerPhone: false,
    // add other fields as needed
  });
  
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;

    if (!touchedWhileTyping[name as keyof typeof touchedWhileTyping]) {
      setTouchedWhileTyping((prev) => ({
        ...prev,
        [name]: true,
      }));
    }

    // Clear error when user starts typing
    if (error) {
      setError(null);
    }

    if (name.startsWith("workingHours.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        workingHours: {
          ...prev.workingHours,
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]:
          type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
      }));



    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    console.log("Submitting Form Data:", JSON.stringify(formData));
    e.preventDefault();

    try {
      console.log("====>step1,", formData);
      if (isEditMode) {
        const response = await dispatch(editBranch({ id: branch.id, branchData: formData }) as any);
        console.log("response from branch: ", response);
        console.log("====>step2,", formData);

        if (response.type.includes('rejected')) {
          setIsFormModified(true);
          setError(response.payload || "Failed to update branch");
          console.log("====>step3,", formData);

          console.log('response.type.includes()');
          console.error("Branch update failed:", response.payload);
          return; // Don't close modal on error
        }
      } else {
        const response = await dispatch(createBranch(formData) as any);

        if (response.type.includes('rejected')) {
          setIsFormModified(true);
          setError(response.payload || "Failed to create branch");
          console.error("Branch creation failed:", response.payload);
          return; // Don't close modal on error
        }
      }

      console.log("Branch operation successful, calling onSuccess");
      setIsFormModified(false);
      setError(null); // Clear any previous errors
      if (onSuccess) {
        onSuccess();
      }
      return; // Close via parent state change, don't trigger onClose
    } catch (error: any) {
      console.error("Error submitting form:", error);
      setIsFormModified(true);
      setError(error.message || "An unexpected error occurred");
      return;
    }
  };


  const validateForm = (): boolean => {
    const {
      name, code, address, state, city, zipCode,
      phone, email, managerName, managerPhone, managerEmail
    } = formData;
  
    // Debug logging
    // console.log('Form validation data:', {
    //   name: name.trim(),
    //   code: code.trim(),
    //   address: address.trim(),
    //   state: state.trim(),
    //   city: city.trim(),
    //   zipCode: zipCode.trim(),
    //   phone: phone.trim(),
    //   email,
    //   managerName: managerName?.trim() || '',
    //   managerPhone: managerPhone?.trim() || '',
    //   managerEmail: managerEmail || ''
    // });

    const zipValid = zipCode?.trim().length === 6; // India pin code length
    const phoneValid = phone?.trim().length === 10; // Fixed: Indian phone numbers are 10 digits
    const managerPhoneValid = managerPhone ? managerPhone.trim().length === 10 : true; // Fixed: proper conditional check
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const managerEmailValid = managerEmail ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(managerEmail) : true; // Fixed: proper conditional check
  
    // Debug logging for validation results
    console.log('Validation results:', {
      zipValid,
      phoneValid,
      managerPhoneValid,
      emailValid,
      managerEmailValid,
      nameValid: name?.trim() !== "",
      codeValid: code?.trim() !== "",
      addressValid: address?.trim() !== "",
      stateValid: state?.trim() !== "",
      cityValid: city?.trim() !== "",
      managerNameValid: managerName ? managerName?.trim() !== "" : true
    });

    const isValid = (
      name?.trim() !== "" &&
      code?.trim() !== "" &&
      address?.trim() !== "" &&
      state?.trim() !== "" &&
      city?.trim() !== "" &&
      zipValid &&
      phoneValid &&
      emailValid &&
      (managerName ? managerName.trim() !== "" : true) && // Fixed: proper conditional check
      managerPhoneValid &&
      managerEmailValid
    );

    console.log('Form validation result:', isValid);
    return isValid;
  };
  
  
  
  const isFormValid = validateForm();
  return (
    // <BaseModal isOpen={isOpen} onClose={onClose} title={isEditMode ? "Edit Branch" : "Create Branch"}>
    <div
      className={`fixed inset-0 z-50 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={() => {
          if (isFormModified) {
            if (window.confirm("You have unsaved changes. Are you sure you want to close?")) {
              onClose();
            }
          } else {
            onClose();
          }
        }}
      ></div>

      {/* Slide-in Panel */}
      <div
        className={`absolute right-0 top-0 h-full w-[30%] bg-white shadow-xl transform transition-transform duration-1000 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full"> 
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              {isEditMode ? "Edit Branch" : "Create Branch"}
            </h2>
            <button
              onClick={!isFormModified  ? onClose : null}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
            >
              ✕
            </button>
          </div>  
          {/* content */}
          <div className="flex-1 overflow-y-auto p-6">
            {error && (
              <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}
                <TextInputField
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  icon={<BuildingOfficeIcon className="h-5 w-5 text-gray-500" />}
                />

                <TextInputField
                  label="Code"
                  name="code"
                  value={formData.code}
                  onChange={handleInputChange}
                  required
                  icon={<IdentificationIcon className="h-5 w-5 text-gray-500" />}
                />
              {/* </div> */}

              <TextInputField
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                required
                icon={<MapPinIcon className="h-5 w-5 text-gray-500" />}
              />

              {/* State, City, ZIP */}
              {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4"> */}
              <StateSelect
                value={formData.state}
                onChange={handleInputChange}
                required
              />

              <CitySelect
                state={formData.state}
                value={formData.city}
                onChange={handleInputChange}
                required
              />

              <ZipCodeField
                label="ZIP Code"
                name="zipCode"
                value={formData.zipCode}
                onChange={handleInputChange}
                required
                showError={touchedWhileTyping.zipCode}
                />
              {/* </div> */}

              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}

                <PhoneField
                  label="Phone"
                  name="phone"
                  value={formData.phone || ""}
                  onChange={handleInputChange}
                  required
                  showError={touchedWhileTyping.phone}
                />
                  <EmailField
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    showError={touchedWhileTyping.email}
                  />
              {/* </div> */}
              {/* manager detail */}
              {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4"> */}

              <TextInputField
                label="Manager Name"
                name="managerName"
                value={formData.managerName || ""}
                onChange={handleInputChange}
                required
                icon={<UserIcon className="h-5 w-5 text-gray-500" />}
              />

              <PhoneField
                label="Manager Phone"
                name="managerPhone"
                value={formData.managerPhone || ""}
                onChange={handleInputChange}
                required
                showError={touchedWhileTyping.managerPhone}
              />

              <EmailField
                label="Manager Email"
                name="managerEmail"
                value={formData.managerEmail || ""}
                onChange={handleInputChange}
                required
                showError={touchedWhileTyping.managerEmail}
              />
              {/* </div> */}


              <div className="flex justify-end space-x-3 mt-6">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
                >
                  Cancel
                </button>         

                <button
                  type="submit"
                  className={`inline-flex items-center mx-4 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white transition-colors ${
                    isFormValid
                      ? "bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600"
                      : "bg-gray-400 cursor-not-allowed"
                  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-offset-secondary-800`}
                  disabled={!isFormValid}
                >
                  {isEditMode ? "Update Branch" : "Create Branch"}
                </button>

              </div>
            
            
            </form>
          </div>
        </div>
      </div>
    </div>

    // </BaseModal>
  );
};

export default CreateBranchModal;
